import React from 'react';
import { Box, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { SearchBar } from './SearchBar';

interface EventToolbarProps {
  onAddEvent: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export const EventToolbar: React.FC<EventToolbarProps> = ({
  onAddEvent,
  searchQuery,
  onSearchChange
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box sx={{ flexGrow: 1 }}>
        <SearchBar
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search events..."
        />
      </Box>

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onAddEvent}
      >
        Add Event
      </Button>
    </Box>
  );
};